import { useCallback, useMemo, useState } from 'react';
import { Dropdown } from '..';
import './index.css';

interface Props {
  config: Dropdown;
}

const DropdownComponent = (props: Props) => {
  const { config } = props;
  const {
    label,
    value,
    handleValueChange,
    isLocked,
    shouldFit,
    options,
    isDisabled,
    fullWidth,
  } = config;

  const availableOptions = useMemo(
    () => options.filter((o) => o !== value),
    [value, options],
  );

  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(
    (option: string | number) => {
      setIsOpen(false);
      handleValueChange(option);
    },
    [handleValueChange],
  );

  const dropdownClassName = `dropdown ${
    (isLocked ? isOpen : isOpen || typeof value !== 'undefined') && 'open'
  } ${isLocked && !isOpen && 'locked'} ${shouldFit && 'fit'}`;

  return (
    <div
      className={dropdownClassName}
      style={{ width: fullWidth ? '100%' : 'auto' }}
    >
      <div
        className="dropdown-trigger"
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          paddingTop: 5,
          paddingLeft: 15,
        }}
        onClick={isDisabled ? undefined : () => setIsOpen((prev) => !prev)}
      >
        <label htmlFor={label}>{label}</label>
        <span id={label} className="dropdown-value">
          {value}
        </span>
      </div>
      {isOpen && (
        <div
          style={{
            width: '95%',
            position: 'absolute',
            top: 58,
            zIndex: 150,
            backgroundColor: 'black',
            boxShadow: '10px 10px 10px 2px rgba(0, 0, 0, 0.4)',
            paddingRight: 20,
          }}
        >
          {availableOptions.map((option) => {
            return (
              <div
                key={`dropdown_${option}`}
                style={{
                  width: fullWidth ? '100%' : 185,
                  height: 56,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  marginTop: 1,
                  paddingLeft: 15,
                }}
                className="dropdown-option"
                onClick={() => handleClick(option)}
              >
                <span style={{ color: 'white', fontSize: 13 }}>{option}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DropdownComponent;
